export const formatPrice = (value: number): number => Number((value < 100 ? value : value / 100).toFixed(2))
